import React from "react";
import T from "prop-types";
import { LOCATION } from "MODULES/inventories/constants";
import withCurrentUser from "MODULES/session/decorators/withCurrentUser";

const LocationsDropDown = ({ currentUser, handleChange, selectedLocation }) => {
  if (currentUser.locations.length === 1) {
    return null;
  }
  return (
    <span>
      <select
        className="form-control"
        name={LOCATION}
        value={selectedLocation && selectedLocation.id}
        onChange={e => handleChange(e.target.value)}
      >
        <option value="">Select Location</option>
        {currentUser.locations.map(l => (
          <option key={l.id} value={l.id}>
            {l.name}
          </option>
        ))}
      </select>
    </span>
  );
};

LocationsDropDown.propTypes = {
  currentUser: T.shape({}).isRequired,
  handleChange: T.func.isRequired,
  selectedLocation: T.shape({})
};

export default withCurrentUser(LocationsDropDown);



// WEBPACK FOOTER //
// ./app/modules/Locations/components/LocationsDropDown.jsx